var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvironment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.5C3.23858 15.5 1 13.336 1 10.6667C1 8.15367 2.98398 6.0886 5.52042 5.85528M16.5 15.5C18.9853 15.5 21 13.5524 21 11.15C21 8.74756 18.9853 6.8 16.5 6.8C16.4925 6.8 16.485 6.80002 16.4776 6.80005M16.4776 6.80005C16.4924 6.64084 16.5 6.47961 16.5 6.31667C16.5 3.38035 14.0376 1 11 1C8.12324 1 5.76233 3.135 5.52042 5.85528M16.4776 6.80005C16.3753 7.89668 15.9286 8.89729 15.2428 9.7M5.52042 5.85528C5.67826 5.84076 5.83823 5.83333 6 5.83333C7.12582 5.83333 8.16474 6.19302 9.00049 6.8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1957 13.1688L9.80434 16.6838C9.56684 17.0431 9.44808 17.2227 9.52165 17.3614C9.59522 17.5 9.80931 17.5 10.2375 17.5H11.7625C12.1907 17.5 12.4048 17.5 12.4783 17.6387C12.5519 17.7773 12.4332 17.9569 12.1957 18.3162L10.4216 21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/environment.dd500c12.svg";
export { ForwardRef as ReactComponent };